// extracted by mini-css-extract-plugin
export default {"fila":"FichaColumnas_fila__f6et-","columna":"FichaColumnas_columna__-5mcm"};